import { render, staticRenderFns } from "./EventTypeChip.vue?vue&type=template&id=5b99f906"
import script from "./EventTypeChip.vue?vue&type=script&lang=js"
export * from "./EventTypeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports